// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { ActionTypes } from "../actions/actionTypes";
import { AnyAction } from "../actions/actionCreators";
import { IUserModelsDetails } from "../../models/applicationState";

/**
 * App Title Reducer
 * Actions handled:
 *  SET_TITLE
 * @param {string} state
 * @param {AnyAction} action
 * @returns {any}
 */
export const reducer = (state: IUserModelsDetails[] = [], action: AnyAction): IUserModelsDetails[] => {
    switch (action.type) {
        case ActionTypes.ALL_MODELS_SUCCESS:
            return action.payload;
        case ActionTypes.DELETE_MODEL_SUCCESS:
            return [...state.filter((model) => model.model_id !== action.payload.model_id)];
        case ActionTypes.LOGGED_OUT_USER:
            return null;
        default:
            return state;
    }
};
